module.exports = __webpack_public_path__ + "img/kv_4_2.a076b3b7.png";